const IconPinteerest = (): JSX.Element => {
  return (
    <>
      <path
        d="M12,0C5.4,0,0,5.4,0,12s3.3,9.6,7.8,11.3c-.1-1.2-.1-3.1.1-4,.2-.9,1.3-5.6,1.3-5.6,0,0-.3-.7-.3-1.7,0-1.6.9-2.7,2-2.7s1.4.7,1.4,1.6-.6,2.4-.9,3.7c-.3,1.1.6,2,1.7,2,2,0,3.5-2.1,3.5-5.1s-1.9-4.6-4.7-4.6-5.1,2.4-5.1,4.9.4,2,.8,2.6c0,.1.1.2,0,.3,0,.4-.3,1.1-.3,1.3,0,.2-.2.2-.4.1-1.4-.7-2.3-2.7-2.3-4.3,0-3.5,2.6-6.8,7.4-6.8s6.9,2.8,6.9,6.5-2.4,7-5.8,7-2.2-.6-2.6-1.3c0,0-.6,2.1-.7,2.7-.2.9-1.2,2.8-1.8,3.6,1.2.4,2.4.6,3.7.6,6.6,0,12-5.4,12-12S18.6,0,12,0Z"
        fill="currentColor"
      />
    </>
  );
};

export default IconPinteerest;
